import type { AnyRouter } from '@tanstack/react-router';

import { tokenStore } from '../../shared/api/token-store';
import { queryClient } from '../../shared/lib/query-client';

const PUBLIC_PATHS = ['/sign-in', '/register', '/auth/'];

// The session died under an open screen: revoked, expired, or signed out in another tab.
export const redirectOnSignOut = (router: AnyRouter): void => {
  tokenStore.onSignedOut(() => {
    const { pathname, href } = router.state.location;
    if (!PUBLIC_PATHS.some((path) => pathname.startsWith(path))) {
      void router.navigate({ to: '/sign-in', search: { next: href, reason: 'signed-out' } });
    }
    queryClient.clear();
  });
};
